import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updatePreferredProfessional } from "../services/update-preferred-professional";

export function useUpdatePreferredProfessional() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      usage_id,
      user_id,
      professional_id,
      is_transition = false,
    }: {
      usage_id: string;
      user_id: string;
      professional_id: string | null;
      // Care team confirmed this change is a transition by Rocket Health; the
      // server records it and the "Transition by RH" tag counts it.
      is_transition?: boolean;
    }) =>
      updatePreferredProfessional(
        usage_id,
        user_id,
        professional_id,
        is_transition,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      queryClient.invalidateQueries({
        queryKey: ["professional-change-requests"],
        exact: false,
      });
      toast({
        title: "Success",
        description: "Preferred professional updated",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to update preferred professional",
        variant: "destructive",
      });
    },
  });
}
